import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "topban" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "firstLine" }, "该患者病程中曾多次诊断为湿疹，", -1)
const _hoisted_4 = { id: "about2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "topback" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "titUrl" }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, "强的松"),
      /*#__PURE__*/_createElementVNode("li", null, "盐酸氯苯那敏"),
      /*#__PURE__*/_createElementVNode("li", null, "依巴斯汀"),
      /*#__PURE__*/_createElementVNode("li", null, "复方甘草酸苷片"),
      /*#__PURE__*/_createElementVNode("li", null, "氯雷他定"),
      /*#__PURE__*/_createElementVNode("li", null, "外用激素"),
      /*#__PURE__*/_createElementVNode("li", null, "盐酸西替利嗪片")
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "blueLine" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "zljg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zljgtit" }, "治疗结果："),
  /*#__PURE__*/_createElementVNode("div", { class: "zljgDesc" }, " 治疗一段时间后仍控制不佳，近期皮疹部位扩大，出现患处疼痛瘙痒难以忍受 ")
], -1)
const _hoisted_8 = { class: "bottomBox" }
const _hoisted_9 = {
  key: 0,
  class: "swperList"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_dIV = _resolveComponent("dIV")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      "moveable-area": "false"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_dIV, { class: "secondLine" }, {
            default: _withCtx(() => [
              _createTextVNode(" 并先后使用以下方案进行治疗： ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_image, {
              onClick: $options.bingshi,
              width: "5.32rem",
              height: "1.1467rem",
              src: require('../assets/fenxi.png')
            }, null, 8, ["onClick", "src"])
          ]),
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_van_image, {
                  width: "5.2667rem",
                  height: "4.8rem",
                  src: require('../assets/gongge.jpg')
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _hoisted_10,
    _createVNode(_component_toNav, { menu: 1 })
  ], 64))
}